module.exports = __webpack_public_path__ + "static/media/parking-circle.1981d307.svg";